<cw-ci-data-table #certReviwerDataTable
tileTitle="certification"
addToolTip="Add a new certification"
refreshToolTip="Reload certification list"
defaultSortField="updatedAt"
defaultSortDirection="desc"
[isSelectable]="isSelectable"
(loadItemsHandler)="loadAssessments($event)"
(addHandler)="addAssessment($event)"
(selectHandler)="selectAssessment($event)"
[items]="assessmentList"
>
<cw-ci-table-column columnName="accountName" columnTitle="Company Name" sortField="account_name" searchField="account_name" filterType="text"></cw-ci-table-column>
<cw-ci-table-column columnName="assessmentName" columnTitle="Name" sortField="name"></cw-ci-table-column>
<cw-ci-table-column columnName="percentComplete" columnTitle="Assessment Progress" sortField="percentComplete" [output]="percentCompleteTemplate"></cw-ci-table-column>
<ng-template let-element #percentCompleteTemplate>
  <div class="custom-progress-bar" [ngClass]="{'progress-not-started':element.percentComplete==0}" style="width:200px">
    <div *ngIf="element.percentComplete>0" class="bg-primary" [ngStyle]="{'width': element.percentCompleteStr}">{{element.percentCompleteStr}}</div>
    <div *ngIf="element.percentComplete==0" class="bg-warn">{{element.percentComplete}}</div>
  </div>
</ng-template>

<cw-ci-table-column columnName="updatedAt" columnTitle="Assessment Updated" sortField="updatedAt" [output]="updatedTemplate"></cw-ci-table-column>
<ng-template let-element #updatedTemplate>{{element.updatedAt | date:'short'}}</ng-template>

<cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action [visible]="element.status === 'COMPLETED'" actionToolTip="View the assessment results" svgIcon="cw:action_toggle_graph" actionColor="primary" [element]="element" (clickHandler)="selectAssessment($event)"></cw-ci-table-column-action>
    <cw-ci-table-column-action *ngIf="element.isAssessmentAllowed === 'true'" [visible]="element.status === 'COMPLETED' && element.isLatest === 1 && element.isActive === 1" actionToolTip="Create a new assessment" svgIcon="cw:action_add" actionColor="primary" [element]="element" (clickHandler)="newAssessment($event)"></cw-ci-table-column-action>
    <cw-ci-table-column-action *ngIf="element.isAssessmentAllowed === 'false' && element.status === 'COMPLETED' && element.isLatest === 1 " [disabled]="element.isAssessmentAllowed === 'false'" matTooltip="Account is currently inactive" svgIcon="cw:action_add" actionColor="primary" [element]="element"></cw-ci-table-column-action>
  </ng-template>
</cw-ci-data-table>